import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {ApiService} from './api.service';
import {CommonUtils} from "../utils/common";

/**
 * Guard zarządzający dostępem do modułu zarządzania treścią artykułów.
 * Weryfikuje po stronie serwera API, czy aktualnie zalogowany użytkownik posiada
 * wymagane uprawnienia do przeglądania i edycji artykułów.
 */
@Injectable({
  providedIn: 'root'
})
export class ArticlesAccessGuard implements CanLoad, CanActivate {
  constructor(
    private apiService: ApiService,
    public commonUtils: CommonUtils
  ) {
  }

  /**
   * Blokuje lub zezwala na asynchroniczne pobranie (Lazy Loading) paczki modułu artykułów.
   * Jeżeli serwer zwróci błąd (np. 403 Forbidden / 401 Unauthorized), proces pobierania
   * kodu źródłowego widoku (JS chunk) zostanie przerwany.
   *
   * @param route Konfiguracja chronionej ścieżki.
   * @param segments Segmenty adresu URL.
   * @returns Observable emitujący wartość logiczną (true w przypadku pomyślnej autoryzacji).
   */
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.apiService.post('/dashboard/articles-access', {}).pipe(take(1), map(response => {
      console.log('check - articles - ok');
      return true;
    }));
  }

  /**
   * Weryfikuje uprawnienia przed fizycznym wyrenderowaniem komponentu powiązanego z artykułami.
   * W przypadku braku uprawnień (odpowiedź negatywna z backendu), deleguje obsługę
   * przekierowania i wyświetlenia komunikatu o błędzie do narzędzi z klasy CommonUtils.
   *
   * @param route Migawka aktywowanej ścieżki.
   * @param state Migawka stanu routera.
   * @returns Observable emitujący wartość logiczną lub drzewo routingu (UrlTree).
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.apiService.post('/dashboard/articles-access', {}).pipe(take(1), map(response => {
      console.log('check - canActivate - articles - ok', response);

      return this.commonUtils.handleHttpResponseShowInfoToast(response, '', 'Nie masz uprawnień do tej strony')
    }));
  }

}
